import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  providerLoading: false,
  providerSearchLoading: false,
  categoryLoading: false,
  success: false,
  error: false,
  providers: [],
  subCategory: [],
  providersSearch: null,
  referralCode: null,
  lobbyBannerList: {},
  bannerloading: {},
  loading: true,
  bannererror: null
};

const casinoLobbySlice = createSlice({
  name: "casinoLobby",
  initialState,
  reducers: {
    getProvidersStart: (state) => {
      state.providerLoading = true;
    },
    getProvidersSuccess: (state, action) => {
      state.providerLoading = false;
      state.success = true;
      state.providers = action.payload;
    },
    getProvidersFailure: (state) => {
      state.providerLoading = false;
      state.error = true;
    },
    getProvidersSearchStart: (state) => {
      state.providerSearchLoading = true;
    },
    getProvidersSearchSuccess: (state, action) => {
      state.providerSearchLoading = false;
      state.success = true;
      state.providersSearch = action.payload;
    },
    getProvidersearchFailure: (state) => {
      state.providerSearchLoading = true;
    },
    getSubCategoryStart: (state) => {
      state.categoryLoading = true;
    },
    getSubCategorySuccess: (state, action) => {
      state.categoryLoading = false;
      state.success = true;
      state.subCategory = action.payload;
    },
    getSubCategoryFailure: (state) => {
      state.categoryLoading = false;
      state.error = true;
    },
    setReferralCode: (state, action) => {
      state.referralCode = action.payload;
    },
    resetReferralCode: (state, action) => {
      state.referralCode = initialState.referralCode;
    },
    getLobbyBannersStart: (state, action) => {
      state.bannererror = null;
      state.bannerloading[action?.payload?.pageType] = true;
      state.loading = true;
    },
    getLobbyBannersSuccess: (state, action) => {
      state.bannerloading[action?.payload?.pageType] = false;
      state.loading = false;
      state.success = true;
      state.lobbyBannerList = { ...state.lobbyBannerList, ...action.payload };
    },
    getLobbyBannersFailure: (state, action) => {
      state.bannerloading[action?.payload?.pageType] = false;
      state.bannerloading = false;
      state.loading = false;
      state.error = true;
    }
  }
});

export const {
  getProvidersStart,
  getProvidersSuccess,
  getProvidersFailure,
  getProvidersSearchStart,
  getProvidersSearchSuccess,
  getProvidersearchFailure,
  getSubCategoryStart,
  getSubCategorySuccess,
  getSubCategoryFailure,
  setReferralCode,
  resetReferralCode,
  getLobbyBannersStart,
  getLobbyBannersSuccess,
  getLobbyBannersFailure
} = casinoLobbySlice.actions;

export default casinoLobbySlice.reducer;
